(function ($) {
    'use strict';

    var ELEM = '[data-fd="text"]';
    var keyCodes = {
        Backspace: 8,
        Tab: 9,
        Enter: 13,
        Esc: 27,
        Delete: 46
    };

    $.widget("fd.control_text", {
        options: {
            callback: function () { },
            iskeyup: false,
            iskeyupdelay: 250,
            maxlength: null,
            minlength: 0,
            repeat: false,
            initial: '',
            parentid: null
        },
        initial: function (value) {
            if (value === undefined) {
                return this.options.initial;
            }

            this.options.initial = value;
            this.element.data('initial', value).attr('data-initial', value);

            return this;
        },
        _create: function () {
            if (!this.options.parentid) {
                this.options.parentid = this.element.closest('[data-fd-parentid]').data('fd-parentid');
            }

            // Convert numeric options
            this.options.iskeyupdelay = Number(this.options.iskeyupdelay);
            this.options.minlength = Number(this.options.minlength);
            this.options.maxlength = this.options.maxlength ? Number(this.options.maxlength) : null;
            if (this.options.maxlength) {
                this.element.attr('maxlength', this.options.maxlength);
            }

            this.initial(this.options.initial || this.element.val());
            this._setEvents();
        },
        _handleBlur: function (event) {
            const self = event.data;
            if (self.element.val() === self.options.initial) {
                return false;
            }
            self._handleSubmit(event);
            return true;
        },
        _handleFocus: function (event) {
            const self = event.data;
            self.initial(self.element.val());
        },
        _handleKeyup: function (event) {
            const self = event.data;
            if (event.which === keyCodes.Esc) {
                self.element.val(self.options.initial).focus();
                return;
            }

            if (event.which === keyCodes.Enter) {
                self._handleSubmit(event);
                return;
            }

            if (self.options.iskeyup) {
                clearTimeout(self._keyupTimer);
                self._keyupTimer = setTimeout(function () {
                    self._handleSubmit(event);
                }, self.options.iskeyupdelay);
            }
        },
        _handleSubmit: function (event) {
            if (this._keyupTimer) {
                clearTimeout(this._keyupTimer);
                this._keyupTimer = null;
            }

            this.options.callback.call(this, { parentID: this.options.parentid, value: this.element.val().trim() }, event);

            if (this.options.repeat) {
                this.element.val(null).initial(null).focus();
            }
        },
        _keyupTimer: null,
        _setEvents: function () {
            this.element.off('blur.fdcontrol keyup.fdcontrol focus.fdcontrol')
                .on('blur.fdcontrol', null, this, this._handleBlur)
                .on('focus.fdcontrol', null, this, this._handleFocus)
                .on('keyup.fdcontrol', null, this, this._handleKeyup);
        },
        _setOption: function (key, value) {
            this.options[key] = value;
        }
    });
}(jQuery));